export const BASE_CURRENCY = "HKD";

export const buildExchangeRateMap = (rates) => {
  if (!Array.isArray(rates) || rates.length === 0) return {};
  return rates.reduce((map, rate) => {
    const code = String(rate?.code ?? "").trim();
    if (!code) return map;
    const value = Number(rate?.value);
    if (Number.isNaN(value)) return map;
    map[code] = value;
    return map;
  }, {});
};

export const resolveInternalExchangeRate = (rateMap, currency) => {
  const code = String(currency ?? "").trim();
  if (!code) return null;
  if (code === BASE_CURRENCY) return 1;
  if (!rateMap || rateMap[code] == null) return null;
  return rateMap[code];
};

export const convertAmountToHkd = (amount, currency, rateMap) => {
  const num = Number(amount);
  if (amount == null || amount === "" || Number.isNaN(num) || num <= 0) {
    return { hkdAmount: null, missingRate: false };
  }

  const rate = resolveInternalExchangeRate(rateMap, currency);
  if (rate == null) {
    return { hkdAmount: null, missingRate: true };
  }

  return {
    hkdAmount: Number((num * rate).toFixed(2)),
    missingRate: false,
  };
};

export const summarizeRecommendedProducts = (products, rateMap) => {
  const list = Array.isArray(products) ? products : [];
  const rows = [];
  const missingCurrencies = new Set();
  let totalHkd = 0;

  list.forEach((product) => {
    const subscribedAmount = product?.subscribedAmount;
    const fundCurrency = product?.fundCurrency;
    const num = Number(subscribedAmount);
    if (subscribedAmount == null || subscribedAmount === "" || Number.isNaN(num) || num <= 0) {
      return;
    }

    const { hkdAmount, missingRate } = convertAmountToHkd(
      subscribedAmount,
      fundCurrency,
      rateMap
    );

    if (missingRate && fundCurrency) {
      missingCurrencies.add(String(fundCurrency).trim());
    }

    if (hkdAmount != null) {
      totalHkd = Number((totalHkd + hkdAmount).toFixed(2));
    }

    rows.push({
      subscribedAmount: num,
      fundCurrency,
      hkdAmount,
      missingRate,
    });
  });

  return {
    totalHkd,
    rows,
    missingCurrencies: [...missingCurrencies],
  };
};
